"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveSafe = exports.deriveProxyWallet = void 0;
const ethers_1 = require("ethers");
const constants_1 = require("../constants");
exports.deriveProxyWallet = (address) => {
    return ethers_1.ethers.utils.getCreate2Address(constants_1.PROXY_WALLET_FACTORY_ADDRESS, ethers_1.ethers.utils.solidityKeccak256(["address"], [address]), constants_1.PROXY_INIT_CODE_HASH);
};
exports.deriveSafe = (address) => {
    return ethers_1.ethers.utils.getCreate2Address(constants_1.SAFE_FACTORY_ADDRESS, ethers_1.ethers.utils.keccak256(ethers_1.ethers.utils.defaultAbiCoder.encode(["address"], [address])), constants_1.SAFE_INIT_CODE_HASH);
};
